module.exports = __webpack_public_path__ + "static/media/oldhead.089eb709.jpg";